import { Component, HostListener, Input } from '@angular/core';
import { ToastType } from '@shared/enum/toast-type';

interface ToastMap {
    [key: string]: string;
}

const TOAST_NOTIFICATION_ICON = {
    [ToastType.ERROR]: 'sctr-icon-alert-circle',
    [ToastType.WARNING]: 'sctr-icon-alert-triangle',
    [ToastType.SUCCESS]: 'sctr-icon-check-circle',
    [ToastType.INFO]: 'sctr-icon-check-circle'
};

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
    @Input() keyToast: string;

    toastPosition: string = 'top-right';
    toastIconMap: ToastMap = TOAST_NOTIFICATION_ICON;

    ngOnInit() {
        this.updateToastPosition(window.innerWidth);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.updateToastPosition(event.target.innerWidth);
    }

    updateToastPosition(width: number) {
        this.toastPosition = width < 768 ? 'top-center' : 'top-right';
    }
}
